export default {
      id: "oc-icon_decline-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_decline",
      toString: function () {
        return this.url;
      }
    }